import { render, staticRenderFns } from "./text-metric.vue?vue&type=template&id=16c9a0e4&scoped=true&"
import script from "./text-metric.vue?vue&type=script&lang=js&"
export * from "./text-metric.vue?vue&type=script&lang=js&"
import style0 from "./text-metric.vue?vue&type=style&index=0&id=16c9a0e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c9a0e4",
  null
  
)

export default component.exports